import { c as _c } from "react/compiler-runtime";
import { P1, P2 } from '@algoacademy/design-system/web/typography/Paragraph';
import { cn } from '@/app/_lib/utils';
type CardProps = {
  title: string;
  details: string;
  children: React.ReactNode;
  dark?: boolean;
  className?: string;
} & React.HTMLAttributes<HTMLDivElement>;
export const MentoringCard = t0 => {
  const $ = _c(32);
  let children;
  let className;
  let details;
  let props;
  let t1;
  let title;
  if ($[0] !== t0) {
    ({
      title,
      details,
      children,
      dark: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = details;
    $[4] = props;
    $[5] = t1;
    $[6] = title;
  } else {
    children = $[1];
    className = $[2];
    details = $[3];
    props = $[4];
    t1 = $[5];
    title = $[6];
  }
  const dark = t1 === undefined ? false : t1;
  let t2;
  if ($[7] !== className) {
    t2 = cn("h-fit rounded-lg border-slate-300 border-b bg-backgroundPrimary transition-colors", className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const t3 = dark ? "border-blue-800 from-blue-700 to-blue-600" : "border-blue-200 from-blue-50 to-blue-100";
  let t4;
  if ($[9] !== t3) {
    t4 = cn("space-y-2 rounded-t-lg border bg-linear-to-r p-6", t3);
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const t5 = dark ? "text-white" : "text-black";
  let t6;
  if ($[11] !== t5) {
    t6 = cn(t5);
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6 || $[14] !== title) {
    t7 = <P1 className={t6}>{title}</P1>;
    $[13] = t6;
    $[14] = title;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = dark ? "text-blue-50" : "text-blue-600";
  let t9;
  if ($[16] !== t8) {
    t9 = cn("whitespace-pre-line", t8);
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== details || $[19] !== t9) {
    t10 = <P2 className={t9}>{details}</P2>;
    $[18] = details;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t4 || $[23] !== t7) {
    t11 = <header className={t4}>{t7}{t10}</header>;
    $[21] = t10;
    $[22] = t4;
    $[23] = t7;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== children) {
    t12 = <div className="rounded-b-lg border-slate-300 border-x p-4 lg:p-6">{children}</div>;
    $[25] = children;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== props || $[28] !== t11 || $[29] !== t12 || $[30] !== t2) {
    t13 = <div className={t2} {...props}>{t11}{t12}</div>;
    $[27] = props;
    $[28] = t11;
    $[29] = t12;
    $[30] = t2;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};